import type { ForceLogoProps } from "../types";

/**
 * HRのForceロゴアイコン
 */
export function ForceLogoHR({ size = 36, ...props }: ForceLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.6719 23.7109H14.2578V18.7812H9.73438V23.7109H7.3125V12.2891H9.73438V16.7656H14.2578V12.2891H16.6719V23.7109Z"
        fill="#0070C0"
      />
      <path
        d="M22.8906 12.2891C23.9271 12.2891 24.7812 12.4141 25.4531 12.6641C26.1302 12.9141 26.6328 13.2917 26.9609 13.7969C27.2891 14.3021 27.4531 14.9401 27.4531 15.7109C27.4531 16.2318 27.3542 16.6875 27.1562 17.0781C26.9583 17.4688 26.6979 17.7995 26.375 18.0703C26.0521 18.3411 25.7031 18.5625 25.3281 18.7344L28.6875 23.7109H26L23.2734 19.3281H21.9844V23.7109H19.5625V12.2891H22.8906ZM22.7188 14.2734H21.9844V17.3594H22.7656C23.5677 17.3594 24.1406 17.2266 24.4844 16.9609C24.8333 16.6901 25.0078 16.2943 25.0078 15.7734C25.0078 15.2318 24.8203 14.8464 24.4453 14.6172C24.0755 14.388 23.5 14.2734 22.7188 14.2734Z"
        fill="#0070C0"
      />
    </svg>
  );
}
